import ICalculatorConfiguration from "../../models/ICalculatorConfiguration";
import { ICalculatorInput } from "../../models/ICalculatorInput";

export default function filterFinishingOptions(
  pricingConfiguration: ICalculatorConfiguration,
  calculatorInput: ICalculatorInput,
) {
  const numberOfPages = calculatorInput.isDuplexSelected
    ? Math.ceil((calculatorInput.pagesBlack + calculatorInput.pagesColour) / 2)
    : calculatorInput.pagesBlack + calculatorInput.pagesColour;

  const filteredFinishingOptions =
    pricingConfiguration.pricingConfiguration.finishingOptions.filter((fo) => {
      if (
        (fo?.availableToPrintingOptions?.filter(
          (po) => po === calculatorInput.selectedPrintingOption,
        )?.length ?? 0) > 0 &&
        fo.appliesTo.filter((at) => {
          if (
            at.paperTypes.includes(calculatorInput.selectedPaperType) &&
            at.selectedPaperSize === calculatorInput.selectedPaperSize &&
            at.pageRangeLow <= numberOfPages &&
            at.pageRangeHigh >= numberOfPages
          ) {
            return true;
          }
          return false;
        }).length > 0
      ) {
        return true;
      }
      return false;
    });
  filteredFinishingOptions.sort((a, b) => a.code.localeCompare(b.code));

  return filteredFinishingOptions;
}
